import {Injectable} from "@angular/core";
import {catchError, Observable, throwError} from "rxjs";

import {RegistrationResponse} from "../../../authentication/api/model/registration-response";
import {BaseApi} from "../../../base.api";
import {UserActivationDto} from "../model/user-activation-dto";
import {HttpErrorResponse} from "@angular/common/http";
import {AccountAlreadyActiveError} from "./error/account-already-active-error";
import {errorCodes} from "./error/error-codes";
import {InvalidActivationLinkError} from "./error/invalid-activation-link-error";
import {PatientDataMissingError} from "./error/patient-data-missing-error";
import {ExternalUserNotFoundError} from "./error/external-user-not-found-error";
import {DuplicateEmailError} from "../../../authentication/api/error/duplicate-email-error";
import {AppointmentInformationDto} from "../model/appointment-information-dto";

@Injectable({providedIn: 'root'})
export class UserActivationApi extends BaseApi {

  getUserActivationInfo(userUuid: string, activationCode: string, language: string): Observable<UserActivationDto> {
    return this.httpClient
      .get<UserActivationDto>(`${this.baseUrl}/public/booking/activation/external-user/${userUuid}/${language}`,
        {
          params: {activationCode: activationCode}
        })
      .pipe(
        catchError((err) => {
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.EXTERNAL_USER_NOT_FOUND) {
            return throwError(() => new ExternalUserNotFoundError(),);
          }
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.ACCOUNT_ALREADY_ACTIVE) {
            return throwError(() => new AccountAlreadyActiveError(),);
          }
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.INVALID_ACTIVATION_LINK) {
            return throwError(() => new InvalidActivationLinkError(),);
          }
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.PATIENT_DATA_MISSING) {
            return throwError(() => new PatientDataMissingError(),);
          }

          return throwError(() => err);
        })
      );
  }

  activateExternalUser(userUuid: string, language: string, userActivationDto: UserActivationDto): Observable<RegistrationResponse> {
    return this.httpClient
      .post<RegistrationResponse>(`${this.baseUrl}/public/booking/activation/external-user/${userUuid}/${language}`, userActivationDto)
      .pipe(
        catchError((err) => {
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.EXTERNAL_USER_NOT_FOUND) {
            return throwError(() => new ExternalUserNotFoundError(),);
          }
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.ACCOUNT_ALREADY_ACTIVE) {
            return throwError(() => new AccountAlreadyActiveError(),);
          }
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.INVALID_ACTIVATION_LINK) {
            return throwError(() => new InvalidActivationLinkError(),);
          }
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.PATIENT_DATA_MISSING) {
            return throwError(() => new PatientDataMissingError(),);
          }
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.EMAIL_ALREADY_TAKEN) {
            return throwError(() => new DuplicateEmailError(userActivationDto.email),);
          }
          return throwError(() => err);
        })
      );
  }

  sendActivationLinkWithAppointmentInfo(phoneNumber: string, appointmentInformationDto: AppointmentInformationDto) {
    return this.httpClient
      .post<void>(
        `${this.baseUrl}/public/booking/activation/send-link/appointment-info`,
        appointmentInformationDto,
        {params: {phoneNumber}})
      .pipe(
        catchError((err) => {
          if (err instanceof HttpErrorResponse && err.error.code === errorCodes.EXTERNAL_USER_NOT_FOUND) {
            return throwError(() => new ExternalUserNotFoundError(),);
          }
          return throwError(() => err);
        })
      )
  }

}
